import React from 'react';
import './privacy.less'
import { setHeader } from '@/util/set-header'
import { withRouter } from 'react-router-dom'
@(withRouter as any)
export default class Privacy extends React.Component<any, any> {

    UNSAFE_componentWillMount() {
        setHeader({
            title: '三一集团隐私政策',
            leftClick: this.leftClick,
        })
    }

    leftClick = () => {
        const { history } = this.props
        if (history.length > 1) {
            history.goBack()
        } else {
            if (window.WebViewBridge) {
                window.WebViewBridge?.navBackMarket?.call(window.WebViewBridge)
            } else if (window.webkit) {
                window.webkit.messageHandlers.navBackMarket.postMessage('');
            }
        }
    }

    render() {
        return (
            <div className="privacy-body">
                <p className="font1" style={{ paddingBottom: '0.2rem' }}>更新时间：2020年04月14日</p>
                <p className="font2">三一集团尊重并保护所有使用服务用户的个人隐私权。为了给您提供更准确、更有个性化的服务，三一集团会按照本隐私权政策的规定使用和披露您的个人信息。但三一集团将以高度的勤勉、审慎义务对待这些信息。除本隐私权政策另有规定外，在未征得您事先许可的情况下，三一集团不会将这些信息对外披露或向第三方提供。三一集团会不时更新本隐私权政策。您在同意三一集团服务协议之时，即视为您已经同意本隐私权政策全部内容。本隐私权政策属于三一集团服务使用协议不可分割的一部分。</p>

                <p className="font2" style={{ paddingTop: '0.2rem' }}>1.适用范围</p>
                <p className="font2">a)在您注册三一集团帐号时，您根据三一集团要求提供的个人注册信息；</p>
                <p className="font2">b)在您使用三一集团网络服务，三一集团自动接收并记录的您的手机上的信息，包括但不限于您的IP地址，访问日期时间，设备型号及H5 Cookie等数据；</p>

                <p className="font2" style={{ paddingTop: '0.2rem' }}>2.信息的使用</p>
                <p className="font2">a)获得您的位置数据，以生成距离您最近的门店列表。</p>

                <p className="font2" style={{ paddingTop: '0.2rem' }}>3.信息披露</p>
                <p className="font2">a)三一集团不会将您的信息披露给不受信任的第三方。</p>
                <p className="font2">b)根据法律的有关规定，或者行政或司法机构的要求，向第三方或者行政、司法机构披露；</p>
                <p className="font2">c)如您出现违反中国有关法律、法规或者三一集团服务协议或相关规则的情况，需要向第三方披露；</p>

                <p className="font2" style={{ paddingTop: '0.2rem' }}>4.信息存储和交换</p>
                <p className="font2">a)三一集团收集的有关您的信息和资料将保存在三一集团及（或）其关联公司的服务器上，这些信息和资料可能传送至您所在国家、地区或三一集团收集信息和资料所在地的境外并在境外被访问、存储和展示。</p>

                <p className="font2" style={{ paddingTop: '0.2rem' }}>5.信息安全</p>
                <p className="font2">a)三一集团帐号均有安全保护功能，请妥善保管您的用户名及密码信息。三一集团通过对用户密码进行加密等安全措施确保您的信息不丢失，不被滥用和变造。尽管有前述安全措施，但同时也请您注意在信息网络上不存在“完善的安全措施”。</p>
            </div>
        )
    }
}